import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import NanoFlex from "./../../../Global/NanoFlex.js";
import * as _ from "lodash";

// COMPONENTS
import { Verbatim } from "../Verbatim/Verbatim.js";

const StyledExportVerbatim = styled(NanoFlex)`
  /* position: relative;
height: -webkit-fill-available; */
  .verbatim {
    justify-content: space-between;
    position: relative;
    height: -webkit-fill-available;
    .verbatimContent {
      padding: 0 16px;
      overflow: unset;
      .verbatimWrapper {
        height: auto;
        justify-content: space-between;
      }
      .headerList {
        justify-content: flex-start;
      }

      .exportRecapFilters {
        .recapTitle {
          margin-bottom: 4px;
        }
        .recapFilterWrapper {
          align-items: stretch;
          .leftAsideWrapper {
            height: auto;
          }
          .rightAsideWrapper {
            width: 100%;
            min-height: auto;
            .recapFiltersList {
              padding: 0;
              flex-wrap: wrap;
              .recapFilterItem {
                padding: 4px 4px 4px 0;
                &:first-child {
                  padding-left: 4px;
                }
                .filterInfo {
                  padding: 8px;
                }
                .closeBtn {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
  /* @media print {
    @page {
      size: landscape;
    }
  } */
  .AIResponseModal {
    width: 0%;
    height: 0%;
    .modalBody {
      width: 100%;
      height: 100%;
      margin: 0px;
    }
  }
`;

export class ExportVerbatim extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();

    import("../../../../styles/palmaresAIExport.scss");
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }
  render() {
    return (
      <StyledExportVerbatim justifyContent="space-between">
        <Verbatim />
      </StyledExportVerbatim>
    );
  }
}
